import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';
import PortfolioInvestListSkeleton from '@components/Group/Portfolio/Skeleton/PortfolioInvestListSkeleton';
import PortfolioInvestSummarySkeleton from '@components/Group/Portfolio/Skeleton/PortfolioInvestSummarySkeleton';

const PortfolioInvestSummary = lazy(
  () => import('@components/Group/Portfolio/PortfolioInvestSummary')
);
const PortfolioInvestList = lazy(
  () => import('@components/Group/Portfolio/PortfolioInvestList')
);

/** 조합 관리 > 상세 > 포트폴리오 상세 > 투자유치이력 */
const InvestHistory = () => {
  return (
    <>
      <ApiErrorBoundary>
        <Suspense fallback={<PortfolioInvestSummarySkeleton />}>
          <PortfolioInvestSummary />
        </Suspense>
      </ApiErrorBoundary>

      <ApiErrorBoundary>
        <Suspense fallback={<PortfolioInvestListSkeleton />}>
          <PortfolioInvestList />
        </Suspense>
      </ApiErrorBoundary>
    </>
  );
};

export default InvestHistory;
